import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {MangaFormatIconPipe} from "../../_pipes/manga-format-icon.pipe";
import {MangaFormatPipe} from "../../_pipes/manga-format.pipe";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {MangaFormat} from "../../_models/manga-format";

@Component({
    selector: 'app-series-format',
    imports: [
        MangaFormatIconPipe,
        MangaFormatPipe,
        NgbTooltip
    ],
    templateUrl: './series-format.component.html',
    styleUrls: ['./series-format.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeriesFormatComponent {

  protected readonly MangaFormat = MangaFormat;

  format = input<MangaFormat>(MangaFormat.UNKNOWN)
  /**
   * Use the browser title vs ngbTooltip
   */
  useTitle = input<boolean>(true);
}
